import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as userDataActions from '../../../actions/userDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appConstants from "../../../constants/appConstants";
import * as appHelper from '../../../helpers/appHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as localStorage from '../../../localStorage/localStorage';

class ResourceUrlLink extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            resource: this.props.resource,
            userData: this.props.userData,
            locale: appHelper.getLocalData(this.props.resource),
            link: {},
            required_label: appHelper.getLocaleString("required_label")
        };
        this.onOpen = this.onOpen.bind(this);
        this.getStatusClass = this.getStatusClass.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.updateResourceObjectResult = this.updateResourceObjectResult.bind(this);

    }

    componentDidMount() {
        this.getAssets();
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.userData !== nextProps.userData){
            this.setState({userData: Object.assign({}, nextProps.userData)});
        }
        if(this.state.lang !== nextProps.lang){
            let link = appHelper.getLinkAsset(this.state.resource);
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.resource),
                link: appHelper.isDefined(link.locale) ? appHelper.getLocalData(link) : link,
                required_label: appHelper.getLocaleString("required_label")
            });
        }
    }

    componentDidUpdate() {

    }

    getAssets() {
        let link = appHelper.getLinkAsset(this.state.resource);
        this.setState({link: appHelper.isDefined(link.locale) ? appHelper.getLocalData(link) : link });

    }

    getStatusClass(){
        let objectUserData = userDataHelper.getAttachmentObjectUserData(this.state.userData, this.state.resource.asset_id);

        if (objectUserData.status === objectConstants.STATUS_NOT_STARTED) {
            return "not-started";
        } else if (objectUserData.status === objectConstants.STATUS_IN_PROGRESS) {
            return "in-progress";
        } else if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
            return "complete";
        }
    }

    onOpen(){
        this.updateResourceObjectResult();
    }

    updateResourceObjectResult(){
        let params ={
            asset_id: this.state.resource.asset_id,
            asset_type_code: this.state.resource.object_type,
            status: objectConstants.STATUS_COMPLETE,
        };

        this.props.actions.updateResourceObjectResult(params).then((userData) => {
            this.props.actions.setSuspendData(userData).then((trackingData) => {
                if(localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2){
                    this.props.actions.setLinkAccessed(this.state.resource.asset_id,this.state.locale.label);
                }
            }).catch(error => {

            });
        }).catch(error => {
        });
    }

    render() {
        return (
            <li className={`resource-link ${this.getStatusClass()}`}>
                <a className="link" href={this.state.link.src} target="_blank" onClick={this.onOpen} dangerouslySetInnerHTML={{__html: this.state.locale.label}} />
                {this.state.resource.required
                    ?
                    <span className="required-label"> - {this.state.required_label}</span>
                    :
                    null
                }
            </li>
        );
    }
}

ResourceUrlLink.propTypes = {
    resource: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

ResourceUrlLink.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, userDataActions, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ResourceUrlLink);



/** WEBPACK FOOTER **
 ** ./src/components/objects/resourceLinks/ResourceUrlLink.js
 **/